export default {
  questionSeparator: '_',
  answersSeparator: '-',
  answerSeparator: ',',
  routes: {
    question: 'tunnel-oac',
    answer: 'tunnel-box-slider',
  },
};
